import setGlobalState from '../core/state/set-global-state';

export default setGlobalState;
